import {
  OR_MANAGEMENT_UPDATE_PANELS,
  DEFAULT_ACTIVE_PANELS,
} from '../../actions/management/managementPanels';

export const initialState = DEFAULT_ACTIVE_PANELS;

export default function managementPanelsReducer(state = initialState, action) {
  switch (action.type) {
    case OR_MANAGEMENT_UPDATE_PANELS:
      return [...action.activePanels];
    default:
      return state;
  }
}
